import { useTranslation } from "react-i18next";
import { mergeClass } from "../../../utils/common";
import MajorTourDestSwiper from "./MajorTourDestSwiper";
import { UiTitle } from "../../../components/text/UiTitle";

const MajorTourDest: FcDiv = ({ className }) => {
  const { t } = useTranslation();
  return (
    <div
      className={mergeClass("flex w-full flex-col justify-center", className)}
    >
      <UiTitle text={t("Popular destination")} />
      <div className="w-full pt-4 sm:pt-10">
        <MajorTourDestSwiper />
      </div>
    </div>
  );
};
export default MajorTourDest;
